import {
  Box,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Hero from "../components/UI/Hero";
import { width } from "@mui/system";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("seo.title.about")}</title>
        <meta name="description" content={t("seo.description.about")} />
        <meta property="og:title" content={t("seo.title.about")} />
        <meta property="og:description" content={t("seo.description.about")} />
      </Helmet>
      <Hero
        title={t("hero.about_us.title")}
        subtitle={t("hero.about_us.subtitle")}
      />
      <Container maxWidth="lg" sx={{ my: 10 }}>
        <Grid container spacing={10} sx={{ mb: 12 }}>
          <Grid item xs={12} sm={7.5}>
            <Box>
              <Typography
                color="primary"
                variant="h3"
                sx={{ mb: 2, display: "block" }}
              >
                Cenaudze SIA
              </Typography>
              <Typography
                color="primary"
                variant="body"
                sx={{ mb: 2, display: "block" }}
              >
                Mani sauc Andrejs Balodis, un ar meža nozari esmu saistīts jau
                vairāk nekā 19 gadus. Liela daļa manas dzīves ir pagājusi,
                braucot pa visu Latviju, veicot dažādus mežsaimnieciskos darbus
                un iepazīstot nozari no praktiskās puses. Droši varu teikt – ar
                mežu esmu uz “Tu”!
                <br />
                <br />
                Esmu neatkarīgs, sertificēts meža vērtētājs, tāpēc manā darbā
                nav nekādu ārēju interešu vai spiediena no iesaistītajām pusēm.
                <br />
                <br />
                Gadu gaitā esmu sadarbojies ar lielākajiem Latvijas meža nozares
                uzņēmumiem, kā arī sniedzis padomus un praktisku palīdzību
                neskaitāmiem meža īpašniekiem. Līdz šim savas prasmes esmu
                pielietojis ap 8047 īpašumos un vairāk nekā 13 680 hektāru meža.
                <br />
                <br />
                {/* Mežs ir mūsu lepnums un bagātība. Tāpēc, leposimies ar to un neizniekosim
                                mums uzticēto vērtību.<br /><br /> */}
                Platformu Cenaudze izveidoju, lai palīdzētu Tev ietaupīt laiku
                meža lietās – sākot no meža inventarizācijas un dokumentu
                sakārtošanas pārdošanai, līdz piemērotākā un izdevīgākā pircēja
                atrašanai.
                <br />
                <br />
                Mūsu komanda un es personīgi atbalstīsim Tevi jebkurā ar mežu
                saistītā jautājumā. Piemēram, ja nezini, kā likumīgi un pareizi
                nocirst daļu sava meža, vari būt drošs – palīdzēsim!
                <br />
                <br />
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            {/* <img src="https://picsum.photos/350/350" sx={{ maxWidth: "100%", height: "100%" }} /> */}
            <Box
              component="img"
              src="/img/sertifikats_1.jpg"
              alt="Sertifikats 1"
              sx={{
                maxWidth: "100%",
                height: "auto", // Maintain aspect ratio
                display: "block", // Remove extra space below the image if any
              }}
            />
            {/* <img src="/img/sertifikats_1.jpg" /> */}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AboutUs;
